import {lazy} from "react";

const IaChat = lazy(() => import("./IaChat"));

const iaChatRoutes = [
    {
        path: "/ia-chat",
        element: <IaChat/>,
    },
];

export default iaChatRoutes;